import { WhisperProps } from 'rsuite';

export const defaultWhisperProps: WhisperProps = {
  placement: 'autoVerticalEnd',
  trigger: 'hover',
  // due to lib auto delay on hover effect (if it is false then will be hidden after time is out (200 ms))
  enterable: true,
};
